module.exports = "<div class=\"c-basket__expires\" ng-if=\"$ctrl.shouldDisplayDate()\">\n    Your basket is valid until <br ng-if=\"!$ctrl.displayInline\">\n    <span>{{ $ctrl.displayDate }}</span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/basket/views/expiresAt.html
// module id = 695
// module chunks = 0